export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_94552)">
                <path
                    d="M25.8 6.5H6.2C5.53726 6.5 5 7.03726 5 7.7V21.5H27V7.7C27 7.03726 26.4627 6.5 25.8 6.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.2276 26.5H4.77244C3.92348 26.5 3.34297 25.6426 3.65827 24.8543L5 21.5H27L28.3417 24.8543C28.657 25.6426 28.0765 26.5 27.2276 26.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 8.5H17" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7177_94552">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
